// import './polyfill/swipe'
// import './basics/tabs'
import './basics/form-validation';
import './basics/dropdown';
import './basics/toggleBodyClass';
import './basics/readmore';
import './components/carousel';
// import './components/article-progress'
// import './components/page-billboard'
// import './components/site-branding'
// import './components/site-header'
import './components/marketingBlock'
import './components/comment'
// import './components/related-articles'

// TODO: Remove this #161151937
(function($){
    jQuery('img').on('error', function () {
        var $img = $(this);
        if ($img.hasClass('updated-img-cdn-load')) return;

        var localpath = '/sites/default/files/flysystem/';
        var remotePath = 'https://cdn.adformatie.nl/';
        // console.log(location.protocol + '//' + location.host + localpath);
        var newSrc = this.src.replace(location.protocol + '//' + location.host + localpath, remotePath).replace(localpath, remotePath);
        this.src = newSrc;
        $img.addClass('updated-img-cdn-load');
    });
})(jQuery);

import '../scss/style.scss';
